/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PermalinkViewContainer_comment = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_comment" | "ReplyListContainer1_comment">;
    readonly " $refType": "PermalinkViewContainer_comment";
};
export type PermalinkViewContainer_comment$data = PermalinkViewContainer_comment;
export type PermalinkViewContainer_comment$key = {
    readonly " $data"?: PermalinkViewContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"PermalinkViewContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermalinkViewContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationThreadContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment"
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '89988be0940e0abdbe5b540429761854';
export default node;
